"use client"

import { Typography, TypographyProps } from "@mui/material"
import React from "react"

// Define props including the component prop
interface EnhancedTypographyProps extends Omit<TypographyProps, "component"> {
  component?: React.ElementType
  as?: React.ElementType
}

/**
 * EnhancedTypography component that allows using 'component' prop without TypeScript errors
 * Use this component instead of Typography when you need to specify the component prop
 */
const EnhancedTypography = React.forwardRef<
  HTMLElement,
  EnhancedTypographyProps
>(({ component, as, children, ...props }, ref) => {
  // If both component and as are provided, component takes precedence
  const htmlComponent = component || as || undefined
  return (
    <Typography {...props} component={htmlComponent as any} ref={ref}>
      {children}
    </Typography>
  )
})

// Adding a display name for better debugging
EnhancedTypography.displayName = "EnhancedTypography"

export default EnhancedTypography
